import { useEffect, useRef, useState } from "react";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { Box, Chip } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Vectocore } from "vectocore";
import { useParams } from "react-router-dom";

interface propsType {
  keyword?: string;
  searchList?: any;
}

const unAuthAPI = new HttpUnAuthApi();
const vectocore = new Vectocore({ baseURL: "https://d16chj2vioey4w.cloudfront.net",
  tenantKey: process.env.REACT_APP_TENANT_KEY });

const SearchBrief = (props: propsType) => {
  const { pk, sk } = useParams();
  const [searchList, setSearchList] = useState<any>([]);

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);
  const [isAtStart, setIsAtStart] = useState(true); // 슬라이드가 처음에 있는지
  const [isAtEnd, setIsAtEnd] = useState(false); // 슬라이드가 끝에 있는지
  const [swiperInstance, setSwiperInstance] = useState<any>(null); // Swiper 인스턴스를 저장

  useEffect(() => {
    if (props.keyword)
      get_web_search();
  }, [props.keyword]);

  const get_web_search = async () => {
    if (props.searchList) {
      make_search_list(props.searchList);
    } else if (props.keyword) {
      const param: any = {
        mode: "WEB",
        question: props.keyword,
        model: "google",
        withImage: true,
        withVideo: true
      }

      const res = await vectocore.extreamSearch(param);
      if (res.code === "200") {
        make_search_list(res.response.result.web);

        const param: any = {
          command: "update_web_search",
          category: pk,
          briefSeq: sk,
          webSearch: res.response.result.web,
        };

        const result = await unAuthAPI.post(param);
        if (result.code === "200") {
        } else {
          console.error("update_web_search : ", res.response.error_msg);
        }
      } else {
        console.error("get_web_search : ", res.response.error_msg);
      }
    }
  }

  const make_search_list = (result: any) => {
    const keys = ["webPages", "videos", "images"];

    const combinedData = [
      ...result.webPages.map((item: any) => ({ ...item, type: "webPages" })), 
      ...result.images.map((item: any) => ({ ...item, type: "images" })), 
      ...result.videos.map((item: any) => ({ ...item, type: "videos" })), 
    ];

    const randomizedData = combinedData.sort(() => Math.random() - 0.5);
    const top10Datas = randomizedData.slice(0, 10);

    setSearchList(top10Datas);
  }

  const stripHtml = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  const extractDomain = (url: string) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname;
    } catch (error) {
      console.error("Invalide URL: ", error);
      return "";
    }
  }

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}.${month}.${day}`;
    } catch (error) {
      console.error("Invalid date format: ", error);
      return "";
    }
  }

  const typeMapping: { [key: string]: string } = {
    webPages: "뉴스",
    images: "이미지",
    videos: "동영상",
  };

  const mapSearchType = (word: string) => {
    return typeMapping[word] || word; // 매핑된 단어가 없으면 원래 단어 반환
  };

  const iconMapping: { [key: string]: string } = {
    webPages: "/images/icon-news.png",
    images: "/images/icon-img.png",
    videos: "/images/icon-play.png",
  };

  const mapSearchTypeIcon = (word: string) => {
    return iconMapping[word] || "";
  }

  const handleSlideChange = (swiper: any) => {
    setIsAtStart(swiper.isBeginning); // 슬라이드가 첫 번째면 true
    setIsAtEnd(swiper.isEnd); // 슬라이드가 마지막이면 true
  };

  return (
    <>
    <Box sx={{ mt: 4 }}>
      <div className="brief-cont">
        {searchList.length > 0 && (
          <div className="rel-brief" style={{ padding: "0px", margin: "0px", width: "100%", maxWidth: "100%" }}>
            <dl style={{ borderTop: "0px" }}>
              <dt>
                비슷한 컨텐츠 보기
                <img src="/images/icon-look.png" alt="" />
                <div style={{ width: "24px" }} />
                {/* 커스텀 화살표 */}
                <div className="swiper-navigation">
                  <div ref={prevRef} className="custom-prev-arrow">
                    <img
                      src="/images/icon-arr-prev-dark.png"
                      alt=""
                      style={{
                        opacity: isAtStart ? 0.2 : 1,
                        cursor: "pointer",
                        pointerEvents: swiperInstance ? "auto" : "none",
                      }}
                    />
                  </div>
                  <div ref={nextRef} className="custom-next-arrow">
                    <img
                      src="/images/icon-arr-next-dark.png"
                      alt=""
                      style={{
                        opacity: isAtEnd ? 0.2 : 1,
                        cursor: "pointer",
                        pointerEvents: swiperInstance ? "auto" : "none",
                      }}
                    />
                  </div>
                </div>
              </dt>
              <dd style={{ flexWrap: "nowrap" }}>
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={25.8}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  modules={[Navigation]}
                  onSwiper={(swiper: any) => {
                    setSwiperInstance(swiper);
                    if (swiper.params.navigation) {
                      const navigation = swiper.params.navigation as any;
                      navigation.prevEl = prevRef.current;
                      navigation.nextEl = nextRef.current;
                      // swiper.navigation.init();
                      swiper.navigation.update();
                    }
                  }}
                  style={{ zIndex: 0, width: "100%" }}
                  onSlideChange={handleSlideChange} // 슬라이드 변경 시 상태 업데이트
                >
                  {searchList.map((data: any, index: number) => (
                    <SwiperSlide
                      key={`alike-list-${index}`}
                      style={{ width: "258px", borderRadius: "0px", height: "100%", alignItems: "start", display: "block" }}
                    >
                      <div
                        key={`alike-list-${index}`}
                        className="brief-box simple"
                        onClick={() => {
                          window.open(data.url || data.hostPageUrl);
                        }}
                        style={{ width: "100%" }}
                      >
                        <div 
                          className="thumb-img" 
                          style={{ height: "170px", backgroundColor: "#fff" }} 
                          onMouseEnter={() => setHoveredIndex(index)}
                          onMouseLeave={() => setHoveredIndex(null)}
                        >
                          {data.thumbnailUrl ? (
                            <img
                              src={data.thumbnailUrl}
                              alt=""
                              onError={(e) => {
                                e.currentTarget.src = "/images/no-image.png";
                                e.currentTarget.className = "noImage";
                              }}
                            />
                          ) : (
                            // <img src="/images/no-image.png" className="noImage" />
                            <div style={{ width: "100%", background: "#fff", border: "1px solid #e1e1e1", borderRadius: "20px", padding: "8px 20px" }}>
                              <div className="brief-summary">
                                <dl>
                                  <dt>
                                    <p style={{ fontSize: "14px", overflow: "hidden", textOverflow: "ellipsis", WebkitLineClamp: 1 }}>
                                      {stripHtml(data.title)}
                                    </p>
                                  </dt>
                                  <div
                                    style={{ 
                                      display: "-webkit-box", // Flexbox 대체로 텍스트 제한
                                      WebkitBoxOrient: "vertical", // 방향 설정
                                      overflow: "hidden", // 넘치는 텍스트 숨김
                                      textOverflow: "ellipsis", // '...' 표시
                                      WebkitLineClamp: 7, // 최대 줄 수 설정
                                      lineClamp: 2, // 브라우저 호환성
                                      fontSize: "10px",
                                    }}
                                  >
                                    {stripHtml(data.snippet)}
                                  </div>
                                </dl>
                              </div>
                            </div>
                          )}
                          
                          <div 
                            style={{
                              position: "absolute",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              borderRadius: "6px",
                              top: "16px",
                              right: "16px",
                              height: "26px",
                              padding: "5.4px",
                              boxSizing: "border-box"
                            }}
                          >
                            <div 
                              style={{ 
                                width: "100%", 
                                height: "100%", 
                                display: "flex", 
                                flexDirection: "row", 
                                justifyContent: "center", 
                                alignItems: "center", 
                                fontSize: "12px", 
                                fontWeight: "700", 
                                color: "#fff" , 
                                transition: "all 0.3s ease-in-out" 
                              }}
                            >
                              <i>
                                <img style={{ transform: "translate(0)" }} src={mapSearchTypeIcon(data.type)} />
                              </i>
                              <span 
                                style={{ 
                                  lineHeight: 1, 
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  maxWidth: hoveredIndex === index? "100px" : "0",
                                  opacity: hoveredIndex === index ? 1 : 0,
                                  transition: "all 0.3s ease-in-out",
                                  paddingLeft: hoveredIndex === index ? "4px" : "0px" 
                                }}
                              >
                                {mapSearchType(data.type)}      
                              </span>
                            </div>
                          </div>
                          {/* {data.image_list.length > 0 ? (
                            <img
                              src={data.image_list[0]}
                              alt=""
                              onError={(e) => {
                                e.currentTarget.src = "/images/no-image.png";
                                e.currentTarget.className = "noImage";
                              }}
                            />
                          ) : (
                            <img src="/images/no-image.png" className="noImage" />
                          )} */}
                        </div>
                        {/* <div className="brief-summary">
                          <dl>
                            <dt style={{ marginBottom: "8px" }}>
                              <p
                                style={{
                                  whiteSpace: "nowrap", // 한 줄로 유지
                                  overflow: "hidden", // 넘치는 부분 숨김
                                  textOverflow: "ellipsis", // 넘치는 부분에 '...' 표시
                                  display: "block",
                                  maxWidth: "100%",
                                }}
                              >
                                {stripHtml(data.name)}
                              </p>
                            </dt>
                            <div
                              style={{ 
                                display: "-webkit-box", // Flexbox 대체로 텍스트 제한
                                WebkitBoxOrient: "vertical", // 방향 설정
                                overflow: "hidden", // 넘치는 텍스트 숨김
                                textOverflow: "ellipsis", // '...' 표시
                                WebkitLineClamp: 2, // 최대 줄 수 설정
                                lineClamp: 2, // 브라우저 호환성
                              }}
                            >
                              {stripHtml(data.snippet)}
                            </div>
                            <div>{extractDomain(data.url)}</div>
                            <div>{formatDate(data.datePublished)}</div>
                          </dl>
                        </div> */}
                      </div>
                    </SwiperSlide>
                  ))}
                  {/* 왼쪽 그라데이션: 처음 슬라이드가 아니면 표시 */}
                  {!isAtStart && <div className="swiper-gradient-left"></div>}

                  {/* 오른쪽 그라데이션: 마지막 슬라이드가 아니면 표시 */}
                  {!isAtEnd && <div className="swiper-gradient-right"></div>}
                </Swiper>
              </dd>
            </dl>
          </div>
        )}
      </div>
    </Box>
    <div style={{ height: "100px", width: "100%" }}></div>
    </>
  )
}

export default SearchBrief;